import React, { useEffect, useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, IconButton } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import MapComponent from './map'; 
import { makeStyles } from '@material-ui/core/styles';
import MapIcon from '@material-ui/icons/Map'; 
import Typography from '@material-ui/core/Typography';
import FullscreenIcon from '@material-ui/icons/Fullscreen';
import { getEnvVariable } from '../../../modules/environmentalList';
import { GetMultipleLocationsByRefId } from '../../modules/map/eps/multipleLocationServices';

const useStyles = makeStyles((theme) => ({
    root: {
        "& .MuiButton-root": {
            fontSize: 11
        }
    },
    blinkingButton: {
        animation: `$blinking 1s infinite`,
        color: 'red'
    },
    "@keyframes blinking": {
        "0%": { opacity: 1 },
        "50%": { opacity: 0 },
        "100%": { opacity: 1 }
    },
    message: {
        marginTop: theme.spacing(2),
        color: 'red',
        fontWeight: 'bold'
    },
    greenLink: {
        color: 'green',
        fontWeight: 'bold'
    },
    dialogTitle: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: theme.spacing(1)        
    },
    dialogTitleText: {
        fontSize: '0.5rem',
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
    },
    dialogContent: {
        minHeight: '400px', // Set the minimum height for the dialog content
        padding:0
    },
    dialogPaper: {
        minWidth: '70%', // Set the width to 70% of the screen
        minHeight: '100%', // Set the height to 70% of the screen
        maxWidth: 'none', // Disable the default maxWidth
        position: 'fixed',
        right: 0,
        top: 0,
        margin: 0,
    },
    buttonContainer: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        gap: theme.spacing(1),
    },
}));

const MapView = (props) => {
    const [open, setOpen] = useState(false);
    const classes = useStyles();
    const [fullScreen, setFullScreen] = useState(false);
    const handleClickOpen = () => {        
        const hasMultiLoc = getEnvVariable('HasMultipleGeomLocations');     
        if (props?.params?.routeid1 && hasMultiLoc === 'Y') {
            loadMultipleLocationData(props.params.routeid1);
        }else{
            setMapData(props);            
        } 
    };
    const [mapData, setMapData] = useState({}); 

    useEffect(() => {
        console.log(props);          
    }, []);

    useEffect(() => {
        if(mapData?.name)
            setOpen(true);                      
    }, [mapData]);

    const handleClose = () => {
        setOpen(false);
    };

    const handleFullScreenToggle = () => {
        setFullScreen(!fullScreen);
    };

    const loadMultipleLocationData = (id) => {
        GetMultipleLocationsByRefId(id).then((response) => {
            if(response?.length > 0) {
                let propsref = {...props};
                propsref.MultipleLocationData = response; 
                setMapData(propsref)                    
            }else{
                setMapData(props)
            }            
        })
    }

    return (
        getEnvVariable("HasMapViewer") === 'Y'  &&
        <div className={classes.root}>
            <IconButton size='small' color='primary'
                    title={'Map'}
                    onClick={handleClickOpen}
                >   
                <MapIcon fontSize="small"  color='secondary'/> 
                {getEnvVariable('IconTitle') === 'Y' 
                && <Typography variant="caption" color='primary'>{'Map'}</Typography>}
            </IconButton>            
            <Dialog
                open={open && mapData?.MapSettings}
                onClose={handleClose}
                classes={{ paper: classes.dialogPaper }} 
                fullScreen={fullScreen}
            >
                <DialogTitle disableTypography className={classes.dialogTitle}>
                    <Typography variant="h6" color="primary" className={classes.dialogTitleText}>
                        Map
                    </Typography>
                    <div className={classes.buttonContainer}>
                        <IconButton onClick={handleFullScreenToggle} color="primary" size='small'>
                            <FullscreenIcon />
                        </IconButton>
                        <IconButton onClick={handleClose} color="primary" size='small'>
                            <CloseIcon />
                        </IconButton>                        
                    </div>                    
                </DialogTitle>
                <DialogContent dividers className={classes.dialogContent}>
                    <MapComponent {...mapData} />
                    <Typography variant="body1" className={classes.message} message="Please wait loading map" />
                </DialogContent>                
            </Dialog>
        </div>
    );
};

export default MapView;